import { useEffect, useState } from "react"
import style from "./potentialCalculationPage.module.css"
import { ResultPopUpCard } from "../components/ResultPopUp/ResultPopUp"
import fusionImg1 from "../assets/fusionImg1.jpeg"
import fusionVideo from "../assets/fusionVideo1.mp4"
import { FusionComponent } from "../components/FusionComponent/FusionComponent"


let projectilesData = {
    Zp:undefined,
    Ap:undefined,
    Zt:undefined,
    At:undefined,
}




export const PotentialBarrier = () => {
    const [resultIsLoading, setResultIsLoading] = useState(false);
    const [showResultPopUp, setShowResultPopUp] = useState(false);
    const [ztmin, setZtmin] = useState(88);
    const [ztmax, setZtmax] = useState(129);
    const periodicTable= {
        1:"H",
        2:"He",
        3:"Li",
        4:"Be",
        5:"B",
        6:"C",
        7:"N",
        8:"O",
        9:"F",
        10:"Ne",
        11:"Na",
        12:"Mg",
        13:"Al",
        14:"Si",
        15:"P",
        16:"S",
        17:"Cl",
        18:"Ar",
        19:"K",
        20:"Ca",
        21:"Sc",
        22:"Ti",
        23:"V",
        24:"Cr",
        25:"Mn",
        26:"Fe",
        27:"Co",
        28:"Ni",
        29:"Cu",
        30:"Zn",
        31:"Ga",
        32:"Ge",
        33:"As",
        34:"Se",
        35:"Br",
        36:"Kr",
        37:"Rb",
        38:"Sr",
        39:"Y",
        40:"Zr",
        41:"Nb",
        42:"Mo",
        43:"Tc",
        44:"Ru",
        45:"Rh",
        46:"Pd",
        47:"Ag",
        48:"Cd",
        49:"In",
        50:"Sn",
        51:"Sb",
        52:"Te",
        53:"I",
        54:"Xe",
        55:"Cs",
        56:"Ba",
        57:"La",
        58:"Ce",
        59:"Pr",
        60:"Nd",
        61:"Pm",
        62:"Sm",
        63:"Eu",
        64:"Gd",
        65:"Tb",
        66:"Dy",
        67:"Ho",
        68:"Er",
        69:"Tm",
        70:"Yb",
        71:"Lu",
        72:"Hf",
        73:"Ta",
        74:"W",
        75:"Re",
        76:"Os",
        77:"Ir",
        78:"Pt",
        79:"Au",
        80:"Hg",
        81:"Tl",
        82:"Pb",
        83:"Bi",
        84:"Po",
        85:"At",
        86:"Rn",
        87:"Fr",
        88:"Ra",
        89:"Ac",
        90:"Th",
        91:"Pa",
        92:"U",
        93:"Np",
        94:"Pu",
        95:"Am",
        96:"Cm",
        97:"Bk",
        98:"Cf",
        99:"Es",
        100:"Fm",
        101:"Md",
        102:"No",
        103:"Lr",
        104:"Rf",
        105:"Db",
        106:"Sg",
        107:"Bh",
        108:"Hs",
        109:"Mt",
        110:"Ds",
        111:"Rg",
        112:"Cn",
        113:"Nh",
        114:"Fl",
        115:"Mc",
        116:"Lv",
        117:"Ts",
        118:"Og",
        119:"119",
        120:"120",
        121:"121",
        122:"122",
        123:"123",
        124:"124",
        125:"125",
        126:"126",
        127:"127",
        128:"128",
        129:"129",
        130:"130",
        131:"131",
        132:"132",
        133:"133",
        134:"134",
        135:"135",
        136:"136",
        137:"137",
        138:"138",
        139:"139",
        140:"140",
        141:"141",
        142:"142",
        143:"143",
        144:"144",
        145:"145",
        146:"146",
        147:"147",
        148:"148",
        149:"149",
        150:"150",
        151:"151",
        152:"152",
        153:"153",
        154:"154",
        155:"155",
        156:"156",
        157:"157",
        158:"158",
        159:"159",
        160:"160",
        161:"161",
        162:"162",
        163:"163",
        164:"164",
        165:"165",
        166:"166",
        167:"167",
        168:"168",
        169:"169",
        170:"170",
        171:"171",
        172:"172",
        173:"173",
        174:"174",
        175:"175",
        176:"176",
        177:"177",
        178:"178",
        179:"179",
        180:"180",
        181:"181",
        182:"182",
        183:"183",
        184:"184",
        185:"185",
        186:"186",
        187:"187",
        188:"188",
        189:"189",
        190:"190",
        191:"191",
        192:"192",
        193:"193",
        194:"194",
        195:"195",
        196:"196",
        197:"197",
        198:"198",
        199:"199",
        200:"200",
        201:"201",
        202:"202",
        203:"203",
        204:"204",
        205:"205",
        206:"206",
        207:"207",
        208:"208",
        209:"209",
        210:"210",
        211:"211",
        212:"212",
        213:"213",
        214:"214",
        215:"215",
        216:"216",
        217:"217",
        218:"218",
        219:"219",
        220:"220",
        221:"221",
        222:"222",
        223:"223",
        224:"224",
        225:"225",
        226:"226",
        227:"227",
        228:"228",
        229:"229",
        230:"230",
        231:"231",
        232:"232",
        233:"233",
        234:"234",
        235:"235",
        236:"236",
        237:"237",
        238:"238",
        239:"239",
        240:"240",
        241:"241",
        242:"242",
        243:"243",
        244:"244",
        245:"245",
        246:"246",
        247:"247",
        248:"248",
        249:"249",
        250:"250",
        251:"251",
        252:"252",
        253:"253",
        254:"254",
        255:"255",
        256:"256",
        257:"257",
        258:"258",
        259:"259",
        260:"260",
        261:"261",
        262:"262",
        263:"263",
        264:"264",
        265:"265",
        266:"266",
        267:"267",
        268:"268",
        269:"269",
        270:"270",
        271:"271",
        272:"272",
        273:"273",
        274:"274",
        275:"275",
        276:"276",
        277:"277",
        278:"278",
        279:"279",
        280:"280",
        281:"281",
        282:"282",
        283:"283",
        284:"284",
        285:"285",
        286:"286",
        287:"287",
        288:"288",
        289:"289",
        290:"290",
        291:"291",
        292:"292",
        293:"293",
        294:"294",
        295:"295",
        296:"296",
        297:"297",
        298:"298",
    }
    const [formData, setFormData] = useState(projectilesData);
    // const [outPutStatus, setOutPutStatus] = useState(1);
    const [physicalConstData, setPhysicalConstData] = useState({
        zp:"NA",
        ap:"NA",
        zt:"NA",
        at:"NA",
        vb:"NA",
        rb:"NA",
        hw:"NA",
        zc:"NA",
        ac:"NA",
        bf:"NA",
        beta2p:"NA",
        beta2t:"NA",
        beta2c:"NA",
        beta3p:"NA",
        beta3t:"NA",
        beta3c:"NA",
        beta4p:"NA",
        beta4t:"NA",
        beta4c:"NA",
        beta6p:"NA",
        beta6t:"NA",
        beta6c:"NA",
        fusionCross:"NA",
        entChannels:{
            z:"NA",
            xm:"NA",
            az:"NA",
            nA:"NA",
            dnz:"NA",
            z1z2:"NA",
            dnzn:"NA",
            zsqa:"NA",
        }
    })

        const handleOnChange = (e) => {
            const { name, value } = e.target;
            setFormData(
                {...formData, [name]:value}
            ) 
        }

        const handleSubmit = (e) => {
            e.preventDefault();
            handleCalculations(formData)
        }

        const entrenceChannelsCalculator = (z1, a1, z2, a2) => {
            let Z=z1+z2;
            let A=a1+a2;
            let N=A-Z;
            let n1=a1-z1;
            let n2=a2-z2;
            let z1z2 = z1*z2;
            let a1a2pow3 = Math.pow(a1, (1/3))+Math.pow(a2, (1/3));
            let isoSpin = (N-Z)/(N+Z);
            let coulombInteractionParameter=z1z2/a1a2pow3;
            let chargeAsymmetry = Math.abs((z1-z2)/(z1+z2));
            let massAsymmetry = Math.abs((a1-a2)/(a1+a2));
            let zsqa = Math.pow(Z, 2)/A;
            let x = 50.883*(1-(1.7826*Math.pow(((A-(2*Z))/(A)),2)));
            let xcn = zsqa/x;
            let xeff = (coulombInteractionParameter*(4/Math.pow((a1*a2),(1/3))))/(x);
            let xm = (0.25*xcn)+(0.75*xeff);
            let dnByZ = Math.abs((n1/z1)-(n2/z2));
            return{
                z:coulombInteractionParameter, 
                xm,
                az:chargeAsymmetry,
                nA:massAsymmetry,
                dnz:dnByZ,
                z1z2,
                dnzn:isoSpin,
                zsqa:zsqa,
            }

        }

        useEffect(() => {
            if(!formData.Zp) return
            console.log("formData.Zp", formData.Zp)
            setZtmin(89-formData.Zp);
            setZtmax(130-formData.Zp);
        },[formData])
        const deformationCalculator = (A, Z)=> {
            let N=A-Z;
            let isoSpin = (N-Z)/(N+Z);
            let b2="NA";
            let b3="NA";
            let b4="NA";
            let b6="NA";
            if(Z<89 || Z>104){
                return {b2:"NA", b3:"NA", b4:"NA", b6:"NA"}
            }else if(Z>=89 && Z<=103){
                if(isoSpin>0.11 && isoSpin<0.36){
                    b3=(-0.22128)+(2.48358*isoSpin)-(5.6136*isoSpin*isoSpin)
                }else{
                    b3="NA"
                }
                if(isoSpin>0.135 && isoSpin<0.246){
                    b4=(0.13647)+(-1.22304*isoSpin)+(2.31013*isoSpin*isoSpin)
                }else{
                    b4="NA"
                }
                if(isoSpin>0.135 && isoSpin<0.246){
                    b6=(-0.17662)+(1.86422*isoSpin)+(-4.70078*isoSpin*isoSpin)
                }else{
                    b6="NA"
                }
                if(isoSpin<0 || isoSpin>0.393){
                    if(isoSpin>0 && isoSpin<0.135){
                        b2=((-6.1289E-4/isoSpin))+(6.81E-3)
                    }else if(isoSpin>0.136 && isoSpin<0.172){
                        b2=(3.6)+(-71.55*isoSpin)+(472.96*isoSpin*isoSpin)-(1041.76*isoSpin*isoSpin*isoSpin)
                    }else if(isoSpin>0.173 && isoSpin<0.227){
                        b2=(1.56)+(-19.56*isoSpin)+(93.55*isoSpin*isoSpin)+(-147.11*isoSpin*isoSpin*isoSpin)
                    }else if(isoSpin>0.228 && isoSpin<0.245){
                        b2=(17.085)+(-209.758*isoSpin)+(859.079*isoSpin*isoSpin)+(-1174.98*isoSpin*isoSpin*isoSpin)
                    }else if(isoSpin>0.245 && isoSpin<0.393){
                        b2=(60.1)+(-951.92*isoSpin)+(5953.79*isoSpin*isoSpin)+(-18382.62*isoSpin*isoSpin*isoSpin)+(28023.49*isoSpin*isoSpin*isoSpin*isoSpin)+(-16881.15*isoSpin*isoSpin*isoSpin*isoSpin*isoSpin)
                    }
                }else{
                    b2="NA"
                }

                return {b2, b3, b4, b6}
            }

        }
        const fissionBarrierCalculator = (Ap,Zp,At,Zt) => {
            let Zc=Zp+Zt;
            let Ac=Ap+At;
            let Nc=(Ac)-(Zc);
            let chargeMassRatio = ((Zp+Zt)*(Zp+Zt))/(Ap+At);
            let bf=null;
            let isoSpin= (Nc-Zc)/(Nc+Zc);

            if(Zc<50 || Zc>130){
                return {bf:"NA"}
            }else{
                if(Zc>=50 && Zc<=60){
                    bf=(131.7082622)+(-32.30853087*Math.log(chargeMassRatio))
                }else if(Zc>=61 && Zc<=70){
                    bf=(1.354393424*Math.pow(isoSpin, -6))+(-32.73084109*Math.pow(isoSpin, -5))+(323.6415679*Math.pow(isoSpin, -4))+(-1673.46199*Math.pow(isoSpin, -3))+(4764.240475*Math.pow(isoSpin, -2))+(-7067.486334*Math.pow(isoSpin, -1))+(4290.484552*Math.pow(isoSpin, 0))
                }else if(Zc>=71 && Zc<=80){
                    bf=(3.672195015E-4*Math.pow(chargeMassRatio, 5))+(-5.013781555E-2*Math.pow(chargeMassRatio, 4))+(2.69317344*Math.pow(chargeMassRatio, 3))+(-71.18883766*Math.pow(chargeMassRatio, 2))+(926.5264429*Math.pow(chargeMassRatio, 1))+(-4729.482557*Math.pow(chargeMassRatio, 0))
                }else if(Zc>=81 && Zc<=88){
                    bf=(-6.856495407E-4*Math.pow(isoSpin, -6))+(4.425040856E-2*Math.pow(isoSpin, -5))+(-1.161968408*Math.pow(isoSpin, -4))+(15.8282142*Math.pow(isoSpin, -3))+(-117.1768935*Math.pow(isoSpin, -2))+(441.7993176*Math.pow(isoSpin, -1))+(-642.7607905*Math.pow(isoSpin, 0))
                }else if(Zc>=89 && Zc<=103){
                    bf=(2.510227449E-5*Math.pow(chargeMassRatio, 6))+(-5.2905770395E-3*Math.pow(chargeMassRatio, 5))+(0.460874845*Math.pow(chargeMassRatio, 4))+(-21.23793846*Math.pow(chargeMassRatio, 3))+(545.957*Math.pow(chargeMassRatio, 2))+(-7422.225418*Math.pow(chargeMassRatio, 1))+(41687.74854*Math.pow(chargeMassRatio, 0))
                }else if(Zc>=104 && Zc<=130){
                    bf=(0.2786491852*Math.pow(isoSpin, -4))+(-6.092349106*Math.pow(isoSpin, -3))+(47.80361058*Math.pow(isoSpin, -2))+(-158.8358275*Math.pow(isoSpin, -1))+(191.9980354*Math.pow(isoSpin, 0))
                }
            }
            return {bf};
        }

        const fusionBarrierRadiusParabolaCalculator = (Ap,Zp,At,Zt) => {
            let zc=Number(Zp)+Number(Zt);
            let ac=Number(Ap)+Number(At);
            let r1=(1.233*Math.pow(Number(Ap),(1/3)))-(0.98*Math.pow(Number(Ap),(-1/3)));
            let r2=(1.233*Math.pow(Number(At),(1/3)))-(0.98*Math.pow(Number(At),(-1/3)));
            let c1 =r1-(1/r1);
            let c2= r2-(1/r2);
            let vb=0;
            let rb=0;
            let hw=0;
            let sb=0;
            let coloumb= ((Number(Zp))*(Number(Zt)))/((Math.pow((Number(Ap)),(1/3))+Math.pow((Number(At)),(1/3))));

            if(zc>88 && zc<131){
                if(zc>88 && zc<104){
                    sb= (-1.236E-7*coloumb*coloumb*coloumb)+(7.774E-5*coloumb*coloumb)+(-2.324E-2*coloumb)+(3.759)
                    rb=sb+c1+c2
                    // rb=(10.921+(0.1032*(((Number(formData?.Ap))^(1/3))+((Number(formData?.At))^(1/3)))))
                    vb=(1.435*((((Number(formData?.Zp))*((Number(formData?.Zt))))/(rb))*(1-(1/rb))))+1.866
                    hw= (1.46E-7*coloumb*coloumb*coloumb)+(-9.4E-5*coloumb*coloumb)+(1.02E-2*coloumb)+4.02
                    return {vb, rb, hw}
                                       
                }else{
                    sb= (-1.236E-7*coloumb*coloumb*coloumb)+(7.774E-5*coloumb*coloumb)+(-2.324E-2*coloumb)+(3.759)
                    rb=sb+c1+c2
                    // rb=(10.879+(0.115*(Math.pow((Number(formData?.Ap)),(1/3))+Math.pow((Number(formData?.At)),(1/3)))))
                    vb=(1.4057*((((Number(formData?.Zp))*((Number(formData?.Zt))))/(rb))*(1-(1/rb))))+5.4746
                    hw= (-3.34E-7*coloumb*coloumb*coloumb)+(1.39E-4*coloumb*coloumb)+(-2.37E-2*coloumb)+5.67
                    return {vb, rb, hw}
                }
            }else{
                return {vb:"NA", rb:"NA", hw:"NA"}
            }
            
        }
        const fusionCrossSectionCalculator = (Ap, Zp, At, Zt, vb, rb, hw, ecmCal) => {
            if(ecmCal=="NA"){
                return {sfuArr:"NA"}
            }else{
                let Ecm =ecmCal;
                let sfuArr=[];
                let sfus=0;
                
                for(let i=Ecm; i<(Ecm+101); i++){
                    if(i<vb){
                        sfus=10*((rb*rb*hw)/(2*i))*Math.log(1+Math.exp((((2*3.14)/(hw))*(i-vb))))
                    }else{
                        sfus=10*(3.14*rb*rb)*(1-(vb/i))
                    }
                    sfuArr.push({ecm:i, sfu:sfus})
                }
                setPhysicalConstData({...physicalConstData, 
                    ["fusionCross"]:sfuArr,
                })
                return {sfuArr}
            }

        }

        
       

        
        const handleCalculations = (formData) => {
            setResultIsLoading(true)
            setPhysicalConstData({...physicalConstData, 
                ["zp"]:formData?.Zp,
                ["ap"]:formData?.Ap,
                ["zt"]:formData?.Zt,
                ["at"]:formData?.At,
                ["zc"]: (Number(formData?.Zp)+Number(formData?.Zt)),
                ["vb"]:fusionBarrierRadiusParabolaCalculator(Number(formData?.Ap),Number(formData?.Zp),Number(formData?.At),Number(formData?.Zt)).vb,
                ["rb"]:fusionBarrierRadiusParabolaCalculator(Number(formData?.Ap),Number(formData?.Zp),Number(formData?.At),Number(formData?.Zt)).rb,
                ["hw"]:fusionBarrierRadiusParabolaCalculator(Number(formData?.Ap),Number(formData?.Zp),Number(formData?.At),Number(formData?.Zt)).hw,
                ["ac"]:(Number(formData?.Ap)+Number(formData?.At)),
                ["bf"]:fissionBarrierCalculator(Number(formData?.Ap),Number(formData?.Zp),Number(formData?.At),Number(formData?.Zt)).bf,
                ["beta2p"]:deformationCalculator(Number(formData?.Ap), Number(formData?.Zp)).b2,
                ["beta2t"]:deformationCalculator(Number(formData?.At), Number(formData?.Zt)).b2,
                ["beta2c"]:deformationCalculator((Number(formData?.Ap)+Number(formData?.At)),(Number(formData?.Zp)+Number(formData?.Zt))).b2,
                ["beta3p"]:deformationCalculator(Number(formData?.Ap), Number(formData?.Zp)).b3,
                ["beta3t"]:deformationCalculator(Number(formData?.At), Number(formData?.Zt)).b3,
                ["beta3c"]:deformationCalculator((Number(formData?.Ap)+Number(formData?.At)),(Number(formData?.Zp)+Number(formData?.Zt))).b3,
                ["beta4p"]:deformationCalculator(Number(formData?.Ap), Number(formData?.Zp)).b4,
                ["beta4t"]:deformationCalculator(Number(formData?.At), Number(formData?.Zt)).b4,
                ["beta4c"]:deformationCalculator((Number(formData?.Ap)+Number(formData?.At)),(Number(formData?.Zp)+Number(formData?.Zt))).b4,
                ["beta6p"]:deformationCalculator(Number(formData?.Ap), Number(formData?.Zp)).b6,
                ["beta6t"]:deformationCalculator(Number(formData?.At), Number(formData?.Zt)).b6,
                ["beta6c"]:deformationCalculator((Number(formData?.Ap)+Number(formData?.At)),(Number(formData?.Zp)+Number(formData?.Zt))).b6,
                ["fusionCross"]:fusionCrossSectionCalculator(Number(formData?.Ap),Number(formData?.Zp),Number(formData?.At),Number(formData?.Zt),fusionBarrierRadiusParabolaCalculator(Number(formData?.Ap),Number(formData?.Zp),Number(formData?.At),Number(formData?.Zt))).sfuArr,
                ["entChannels"]: entrenceChannelsCalculator(Number(formData?.Zp),Number(formData?.Ap),Number(formData?.Zt),Number(formData?.At))
            })
            setResultIsLoading(false)
            setShowResultPopUp(true)            
        }


    return(
        <>
        <div className={style.potentialBarrierContainer}>
            <div className={style.innerContainer}>
                <div className={style.heading}>
                    Kolar Heavy Ion fusion barrier Characteristics
                </div>
                <div className={style.contentsContainer}>
                    <div className={style.contentsFirstContainer}>
                        <form action="" onSubmit={handleSubmit} className={style.formContainer}>

                            <label htmlFor="input">Z<sub>P</sub> (Projectile atomic number)</label>
                            <input required={true} min={1} max={130} value={formData.Zp} type="number" name="Zp" className={style.inputBox} onChange={(e) => handleOnChange(e)}/> ({"Please enter in between 6< Zp < 52"})
                            <label htmlFor="input">A<sub>P</sub> (Projectile mass Number)</label>
                            <input required={true} min={1} max={500} value={formData.Ap} type="number" name="Ap" className={style.inputBox} onChange={(e) => handleOnChange(e)}/> ({"Please enter in between 13< Zp < 130"})
                            <label htmlFor="input">Z<sub>T</sub> (Target atomic number)</label>
                            <input required={true} min={ztmin} max={ztmax} value={formData.Zt} type="number" name="Zt" className={style.inputBox} onChange={(e) => handleOnChange(e)}/> ({`Please enter in between ${ztmin}< Zt < ${ztmax}`})
                            <label htmlFor="input">A<sub>T</sub> (Target mass Number)</label>
                            <input required={true} min={1} max={500} value={formData.At} type="number" name="At" className={style.inputBox} onChange={(e) => handleOnChange(e)}/> ({"Please enter in between 120< Zp < 252"})
                            <input type="submit" className={style.submitBtn} name="Calculate" value={"Calculate"}/>
                        </form>
                    </div>
                    <div className={style.imagesContainer}>
                        <div className={style.imagesInnerContainer}>
                            {/* <video src={fusionVideo} alt="fusionVideo" autoPlay muted loop playsInline /> */}
                            <FusionComponent {...{formData}}/>
                        </div>
                        {/* <div className={style.imagesInnerContainer}>
                            <img src={fusionImg1} alt="fusionImg1"/>
                        </div> */}
                    </div>
                </div>
            </div>
        </div>
        {
          showResultPopUp&&  
        //   true&&
          <ResultPopUpCard {...{ fusionCrossSectionCalculator, setPhysicalConstData, resultIsLoading, setResultIsLoading, showResultPopUp, setShowResultPopUp, physicalConstData }}/>
        }
        </>
    )
}